import React from 'react';

// Classnames
import clsx from 'clsx';

// Lib
import { useAppDispatch } from 'lib/hooks/useDispatch';

// Actions
import { getClearTime } from 'pages/Timer/reducer';
import * as actionsCreator from 'pages/Thesaurus/reducer';

// Components
import Tag from './Tag';
import Button from 'components/UiKit/Button';

// Type
import { TTag } from 'pages/Search/type';

// Interface
interface ITargetBox {
	tags?: TTag[],
	isLimit?: boolean,
	className?: string,
}

export const TargetBox: React.FC<ITargetBox> = (props) => {
	const {
		tags = [],
		className = '',
		isLimit = false
	} = props;
	const dispatch = useAppDispatch();

	const filteredData = (data: TTag[], key: number) =>
		data.filter((item: TTag) => item.targetId !== key);

	const deleteTag = (id: number) => {
		const arr = filteredData(tags || [], id);
		const arrayKeys = arr.map((item: any) => item.key);

		dispatch(actionsCreator.handlerUpdateTags(arr));
		dispatch(actionsCreator.handlerChangeCheckedGtf(arrayKeys));
	};

	const clearAll = () => {
		dispatch(actionsCreator.handlerUpdateTags([]));
		dispatch(actionsCreator.handlerChangeCheckedGtf([]));

		dispatch(getClearTime(true));
	};

	const cnTags = clsx(
		'search-bio__tags d-flex flex-wrap flex-ai-start',
		isLimit ? 'search-bio__tags--active' : ''
	);

	const cnWrapper = clsx(
		'search-bio__target-box flex flex-ai-start flex-jc-between mt20 mb15 relative',
		className ? className : ''
	);

	const isDisabled = !tags?.length;

	return (
		<div className={cnWrapper}>
			<div className="flex flex-ai-start flex-direction-column-mobile">
				<p className="search-bio__target-box-text mr10 mb5">
					Target box *:
				</p>
				<div className={cnTags}>
					{!!tags?.length
						? tags.map((item: TTag, i: number) => (
							<Tag
								item={item}
								deleteTag={deleteTag}
								key={`${item?.name}_${item.key}_${i}`}
							/>
						))
						: null}
				</div>
			</div>

			<Button
				variable="href"
				color="green"
				label="Clear all"
				onPress={clearAll}
				disabled={isDisabled}
				className="search-bio__btn-clear-all"
			/>
		</div>
	);
};

export default TargetBox;
